import React, { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import swal from 'sweetalert';
import Table from 'react-bootstrap/Table';
import Wizard from '../Wizard';
import { loaderEnd, loaderStart, notification } from '../../components/loader';
import { getSlots, getCenter, getAvailability, updateAvailability, initiatePayment, getAllSubjects, cancelExam } from "./api";
import { dayInFuture, dateStandard, getTimeDifferenceInMinutes } from "../../shared/dateFn";
import ModalLayout from '../../components/modalLayout';
import ApplyModal from './applyModal';
import ResultModal from './resultModal';
import { getAdmitCard } from "../AdmitCard/api"


import "./styles.css";


const ExamSection = () => {
    const navigate = useNavigate()

    const [allSubject, setAllSubject] = useState([])

    const [allCenter, setAllCenter] = useState([])
    // const [allMonth, setAllMonth] = useState([])
    const [allSlotRange, setAllSlotRange] = useState([])
    const [disableDay, setDisableDay] = useState([])
    const [allHighlight, setAllHighlight] = useState([])
    const [modalResult, setModalResult] = useState(false)
    const [activeDate, setActiveDate] = useState(null)
    const [modalApply, setModalApply] = useState(false)
    const [modalCancel, setModalCancel] = useState(false)
    const [allData, setAllData] = useState(null)

    useEffect(() => {
        getDataApproved()
        getData()
        let sunday = dayInFuture(7)
        // let saturday = dayInFuture(6)
        setDisableDay([...sunday])
    }, [])

    const getDataApproved = async () => {
        loaderStart()
        let res = await getAdmitCard()
        if (res.code && res.data.userDet?.status != "INACTIVE") {
            if(res.data.userDet?.is_approved == 1){
                // navigate("/application")
            }
            else{
                navigate("/application")
            }
        }
        else{
            navigate("/application")
        }
        loaderEnd()
    }

    const getData = async () => {
        loaderStart()
        let subject = await getAllSubjects();
        if (subject.code == 1) {
            setAllData(subject.data);
            generateSubjectWiseData(subject.data)
        }
        loaderEnd()

        let res1 = await getCenter();
        if (res1.code == 1) {
            setAllCenter(res1.data)
        }
    }


    const generateSubjectWiseData = (data) => {
        let _rows = []
        data?.subjects?.map((s) => {
            let past = data?.pastResults?.filter((p) => p.subject_code == s.subject_code)
            let future = data?.futureExams?.filter((p) => p.subject_code == s.subject_code)
            let pendingAdmitCard = data?.pendingAdmitCard.filter(f => f.subject_code == s.subject_code)
            _rows.push({
                ...s,
                past,
                future,
                isEmptyAdmitCard:pendingAdmitCard.length ? false : true,
            })
        })
        setAllSubject(_rows)
    }

    const checkResult = (data) => {        
        let final = false
        if (data.future.length == 0 && data.isEmptyAdmitCard) {
            final = true
            data.past?.map((d) => {
                if (d.exam_status == "PASS" && final) {
                    final = false;
                }
            })
        }
        return final;
    }

    const generateTable = () => {
        let _rows = []

        allSubject?.map((s) => (
            // subject_code is unique per row; without a key React cannot match
            // rows across re-renders and warns.
            _rows.push(<tr key={s.subject_code}>
                <td>{s.subName}</td>
                <td>{s.past.length}</td>
                <td>
                    {s.past.length > 0
                        ? <button type="button" className="ui_action" onClick={() => setModalResult(s)}>
                            <i className="fa fa-clipboard-check" aria-hidden="true"></i>
                            View result
                          </button>
                        : <span className="ui_muted">—</span>}
                </td>
                <td>
                    {s.future.length > 0 ? <>
                        <button type="button" className="ui_action" onClick={() => navigate("/admit-card/" + s.subject_code)}>
                            <i className="fa fa-address-card" aria-hidden="true"></i>
                            Admit card
                        </button>
                        {/* <i className="fa fa-trash" style={{ color: "red" }} onClick={() => setModalCancel(s.future[0])} aria-hidden="true"></i> */}
                    </> : <span className="ui_muted">—</span>}
                </td>
                <td>
                    {checkResult(s)
                        ? <button type="button" className="ui_action ui_action_primary" onClick={() => checkLastPayment(s)}>
                            <i className="fa fa-pencil-alt" aria-hidden="true"></i>
                            Apply
                          </button>
                        : <span className="ui_muted">—</span>}
                </td>
                <td><span className="ui_muted">—</span></td>
            </tr>)
        ))
        return _rows;
    }

    const handleCancelExam = async () => {
        // console.log((modalCancel));
        loaderStart()
        let res = await cancelExam(allData?.userDet?.user_id, modalCancel.exam_id);
        if (res.code == 1) {
            getData()
            notification(true, "Success")
            setModalCancel(false)
        }
        else {
            notification(false, res.message)
        }
        loaderEnd()
    }

    const checkLastPayment = (s) => {
        if (allData?.lastPaymentDetails?.trnReqDate && allData?.lastPaymentDetails?.trnReqDate !== "NA" && getTimeDifferenceInMinutes(allData?.lastPaymentDetails?.trnReqDate) <= 30) {
            swal("Please wait for 30 minutes for slot confirmation and then try again.", "", "error")
            return false;
        }
        else {
            setModalApply(s)
        }
    }

    return (
        <>
            <div className="card  application-box">
                {/* Same header bar the wizard screens carry, so Back sits in
                    the same place and looks the same on every screen. This one
                    is standalone — Exam is not part of the wizard — so the bar
                    is written out rather than pulled from <Wizard>, which also
                    renders the step indicator. */}
                <div className="card-header">
                    <div className="card-header-container">
                        <div>
                            <Link to="/application">
                                <button type="button" className="btn btn-warning btn-sm">
                                    <i className="fa fa-arrow-left"></i>&nbsp;Back
                                </button>
                            </Link>
                        </div>
                        <div>
                            <i className="fa fa-laptop"></i>&nbsp;Examinations
                        </div>
                        <div></div>
                    </div>
                </div>
                <form className="row g-3">
                    <div id="applications" className='application-body application-form-box'>
                        <div className='card application-form overflowX'>
                            <h2 className='ui_section_title'>Examination Details</h2>
                            <p className='confirmation'>
                                <i className='fa fa-info-circle' aria-hidden='true'></i>
                                After paying, please allow up to 30 minutes for your slot to be confirmed.
                            </p>
                            {/* <p align="center"><i style={{ color: 'red', fontSize: '16px' }} >
                                Exam will be conducted only on saturdays of every month for without training candidates.
                                <br />Slots will be announced every two weeks for with training candidates. <br />Training will be conducted with minimum of 25 candidates else next slot wil be alloted. </i></p> */}

                            <div className='ui_table_wrap'>
                            <Table className='ui_table'>
                                <thead>
                                    <tr>
                                        <th>Subject</th>
                                        <th>Attempt</th>
                                        <th>Result</th>
                                        <th>Admit Card</th>
                                        <th>Apply</th>
                                        <th>Waitlist date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {generateTable()}
                                </tbody>
                            </Table>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            {
                modalApply
                    ?
                    <ModalLayout
                        modal={modalApply}
                        title="Apply"
                        toggle={() => setModalApply(false)}
                    >
                        <ApplyModal
                            allCenter={allCenter}
                            data={modalApply}
                            toggle={() => setModalApply(false)}
                        />
                    </ModalLayout>
                    : null
            }
            {
                modalResult
                    ?
                    <ModalLayout
                        modal={modalResult}
                        title="Result"
                        toggle={() => setModalResult(false)}
                    >
                        <ResultModal
                            data={modalResult}
                        />
                    </ModalLayout>
                    : null
            }
            {
                modalCancel
                    ?
                    <ModalLayout
                        modal={modalCancel}
                        title="Cancel Slot"
                        toggle={() => setModalCancel(false)}
                    >
                        Do you want to cancel this slot?
                        <br />
                        <br />
                        <div style={{ textAlign: "center" }}>
                            <button onClick={() => handleCancelExam()} className="btn btn-danger" type="submit">Yes</button>
                        </div>

                    </ModalLayout>
                    : null
            }
        </>
    )
}

export default ExamSection